import "./style.css";

export default function Faq() {
  return (
    <div className="faq-container">
      <h2 className="faq-title">Perguntas frequentes</h2>

      {/*FAQ Itens*/}
      <div className="accordion" id="accordionExample">

        {/* Item 1 */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
              Essa mentoria é pra quem está começando agora?
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              Sim! A mentoria foi desenvolvida tanto para iniciantes quanto para profissionais que já atuam na área, mas sentem que estão estagnados e precisam crescer de verdade.
            </div>
          </div>
        </div>

        {/* Item 2 */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
              Não sou bom com internet. Isso vai atrapalhar?
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              De forma alguma. O curso foi pensado para quem tem pouca ou nenhuma experiência com redes sociais. Você vai aprender o básico ao avançado de forma prática, com foco no que realmente dá resultado.
            </div>
          </div>
        </div>

        {/* Item 3 */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
              Vai me ajudar a ter mais clientes?
            </button>
          </h2>
          <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              Sim. A mentoria mostra exatamente como atrair, fidelizar e valorizar seus serviços. Inclusive, você vai aprender a cobrar melhor e se destacar no digital.
            </div>
          </div>
        </div>

        {/* Item 4 */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
              É só teoria ou vou aprender na prática?
            </button>
          </h2>
          <div id="collapseFour" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              Tudo é pensado para a prática. O Wilson traz exemplos reais, estratégias aplicáveis e ferramentas que você já pode usar no dia a dia do seu salão ou atendimento.
            </div>
          </div>
        </div>

        {/* Item 5 */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
              Em quanto tempo vou ver resultado?
            </button>
          </h2>
          <div id="collapseFive" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body">
              Depende do seu nível de dedicação. Mas muitos alunos relatam mudanças já nas primeiras semanas, principalmente na organização, no posicionamento e na captação de clientes.
            </div>
          </div>
        </div>

        {/* Item 6 */}
        <div className="accordion-item">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
              E se eu não gostar da mentoria?
            </button>
          </h2>
          <div id="collapseSix" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
            <div className="accordion-body">
                Você tem 7 dias de garantia incondicional. Se não for pra você, devolvemos 100% do valor, sem burocracia.
              <div className="faq-cta">
                <a href="https://wa.me/554284093699" target="_blank" rel="noreferrer">
                  <button>Agende agora!</button>
                </a>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};